import {
    FaFacebookF,
    FaInstagram,
    FaWhatsapp,
    FaYoutube,
    FaPhoneAlt,
    FaEnvelope,
    FaMapMarkerAlt,
} from "react-icons/fa";

function Footer() {
    return (
        <footer className="bg-slate-900 text-gray-300">

            {/* ================= FOOTER TOP ================= */}
            <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

                {/* HOSPITAL INFO */}
                <div>
                    <h3 className="text-xl font-semibold text-white mb-4">
                        Gavli Hospital Kurawar
                    </h3>
                    <p className="text-sm leading-relaxed">
                        Gavli Hospital Kurawar provides 24×7 emergency services,
                        expert doctors, modern diagnostics, and compassionate
                        patient care for the community.
                    </p>
                </div>

                {/* SOCIAL MEDIA */}
                <div>
                    <h4 className="text-lg font-semibold text-white mb-4">
                        Connect With Us
                    </h4>

                    <div className="flex flex-col gap-3">

                        <a
                            href="https://www.facebook.com/share/174LuTCWpw/" target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 hover:text-white transition"
                        >
                            <span className="w-9 h-9 flex items-center justify-center rounded-full bg-blue-600">
                                <FaFacebookF />
                            </span>
                            Facebook
                        </a>

                        <a
                            href="https://www.instagram.com/gavli_hospital_?igsh=MWJyazJiejFhY3p2Mw=="
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 hover:text-white transition"
                        >
                            <span className="w-9 h-9 flex items-center justify-center rounded-full bg-pink-600">
                                <FaInstagram />
                            </span>
                            Instagram
                        </a>

                        <a
                            href="https://wa.me/919669891909"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 hover:text-white transition"
                        >
                            <span className="w-9 h-9 flex items-center justify-center rounded-full bg-green-500">
                                <FaWhatsapp />
                            </span>
                            WhatsApp
                        </a>

                    </div>
                </div>

                {/* CONTACT INFO */}
                <div>
                    <h4 className="text-lg font-semibold text-white mb-4">
                        Contact Us
                    </h4>

                    <a
                        href="https://maps.google.com/?q=GAVLI+HOSPITAL+Kurawar"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 text-sm mb-2 hover:text-white transition"
                    >
                        <FaMapMarkerAlt />
                        Kurawar, Madhya Pradesh
                    </a>

                    <a
                        href="tel:+919755833739"
                        className="flex items-center gap-2 text-sm mb-2 hover:text-white transition"
                    >
                        <FaPhoneAlt />
                        Emergency: +91 97558 33739
                    </a>

                    <a
                        href="mailto:gavlihospital@gmail.com"
                        className="flex items-center gap-2 text-sm hover:text-white transition break-all"
                    >
                        <FaEnvelope />
                        gavlihospital@gmail.com
                    </a>
                </div>

                {/* MAP */}
                <div>
                    <h4 className="text-lg font-semibold text-white mb-4">
                        Find Us
                    </h4>

                    <iframe
                        title="Gavli Hospital Map"
                        src="https://www.google.com/maps?q=GAVLI+HOSPITAL+Kurawar&output=embed"
                        className="w-full h-40 rounded-lg border-0"
                        loading="lazy"
                    />
                </div>

            </div>

            {/* ================= FOOTER BOTTOM ================= */}
            <div className="border-t border-slate-700 py-4 text-center text-sm text-gray-400">
                © {new Date().getFullYear()} Gavli Hospital Kurawar. All Rights Reserved.
            </div>

        </footer>
    );
}

export default Footer;
